import { useEffect } from "react";
import React from "react";
import { Formik } from "formik";
import Header from "./Header";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";

// create a schema for validation
const schema = Yup.object().shape({
    email: Yup.string()
      .required("Email is a required field")
      .email("Invalid email format"),
    password: Yup.string()
      .required("Password is a required field")
      .min(8, "Password must be at least 8 characters"),
  });
  
  const Login = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

    const path = useLocation();
    const isLogin = path.state?.data;
    // console.log(isLogin)
  
    useEffect(() => {
      if (token?.length === 100) {
        navigate(-1);
      }
    }, []);

    // useEffect(() => {
    //   <Header />
    // },[isLogin])
  
    function handleNavigate(values) {
      // setTimeout for navigate from login page to home page
      setTimeout(() => {
        // generate random String of 100 character
        const genRandomStringNthChar = () => {
          return [...Array(100)]
            .map(() => Math.random().toString(36)[2])
            .join("");
        };
        // store token in local storage
        localStorage.setItem("token", genRandomStringNthChar());
        navigate(-1);
      }, 0);
    };
  
    if(token?.length === 100) return null;
  
    return (
      <>
        {/* Wrapping form inside formik tag and passing our schema to validationSchema prop */}
        <Formik
          validationSchema={schema}
          initialValues={{ email: "", password: "" }}
          onSubmit={(values) => {
            // call handleNavigate and pass input filed data
            handleNavigate(JSON.stringify(values));
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <div className="login-container">
              <div className="login-form">
                {/* Passing handleSubmit parameter to html form onSubmit property */}
                <form noValidate onSubmit={handleSubmit}>
                  <span>Login</span>
                  {/* Our input html with passing formik parameters like handleChange, values, handleBlur to input properties */}
                  <input
                    type="email"
                    name="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    placeholder="Enter your email"
                    className="form-control inp_text"
                    id="email"
                  />
                  {/* If validation is not passed show errors */}
                  <p className="error">
                    {errors.email && touched.email && errors.email}
                  </p>
                  {/* input with passing formik parameters like handleChange, values, handleBlur to input properties */}
                  <input
                    type="password"
                    name="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    placeholder="Enter your password"
                    className="form-control"
                  />
                  {/* If validation is not passed show errors */}
                  <p className="error">
                    {errors.password && touched.password && errors.password}
                  </p>
                  {/* Click on submit button to submit the form */}
                  <button type="submit"
                   onClick={() => {navigate("/", {state: {data: !isLogin}})}}>Login</button>
                </form>
              </div>
            </div>
          )}
        </Formik>
      </>
    );
  };
  
  export default Login;